export const environmentDev = {
    production: false,
    nui: "0",
    canal: "otrosicleintes_QA",
    requiere_firma: true,
    session: "session",
    tokenUrl: "https://api.satelitales.col.test.bayport-digital.com/bayport-api-mgr/login",
    urlBase: "https://api.satelitales.col.test.bayport-digital.com/bayport-api-mgr/api/test-ado/cliente/findByNumberId",
    urlConsultaEstado: "https://api.satelitales.test.bayport-digital.com/v1/legalother/api/v1/documents/get-doc"
};
